import { render, staticRenderFns } from "./RoleCreateEdit.vue?vue&type=template&id=bb2b77e8"
import script from "./RoleCreateEdit.vue?vue&type=script&lang=js"
export * from "./RoleCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports